module.exports = __webpack_public_path__ + "img/send-icon.e19339ee.svg";